import React, {useEffect, useState} from 'react';
import {ApiResponse} from '@interface/common';
import CustomButton from '@component/CustomButton';
import axios, {HttpStatusCode} from 'axios';
import {useForm} from 'react-hook-form';
import CustomValidFormInput from '@component/form/CustomValidFormInput';
import {User} from '@interface/master/UserManagementIF';
import CustomValidFormCheckbox from '@component/form/CustomValidFormCheckbox';
import {useCookies} from 'react-cookie';
import {Modal} from 'antd';
import FindIdPopup from '@page/FindIdPopup';
import FindPasswordPopup from '@page/FindPasswordPopup';

const Login = () => {
    const {register: saveFormRegister
        , control: saveFormControl
        , handleSubmit: saveFormHandleSubmit
        , setValue: saveFormSetValue
        , getValues:saveFormGetValues} = useForm<{ userId: string, passwd: string, isRememberId:boolean }>({mode:'onChange'});

    const [cookies, setCookie, removeCookie] = useCookies(['id'], {doNotParse: true});
    // 아이디찾기 / 비밀번호찾기 모달 (운영 jar 번들에서 복원)
    const [findIdOpen, setFindIdOpen] = useState<boolean>(false);
    const [findPasswordOpen, setFindPasswordOpen] = useState<boolean>(false);

    const handleLogin = async() => {
        const param =   {userId:saveFormGetValues('userId'), passwd:saveFormGetValues('passwd')};
        const {data} = await axios.post<ApiResponse<User>>('/api/login',param);
        if(data.code === HttpStatusCode.Ok && data.item?.userId) {
            saveFormGetValues('isRememberId')?setCookie('id', saveFormGetValues('userId')): removeCookie('id');
            location.href = location.pathname;
        }
        return data;
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            saveFormHandleSubmit(handleLogin)();
        }
    };


    useEffect(() => {
        if(cookies.id) {
            saveFormSetValue('userId',  cookies.id);
            saveFormSetValue('isRememberId', true);
        }

    }, []);

    return (
        <>
            <div className='login-dim'></div>
            <div className='login-wrap'>
                <h2 className='logo'>국가지점번호 센서관리 시스템</h2>

                <form className={'ant-form'} onSubmit={saveFormHandleSubmit(handleLogin)}>
                    <div className={'ant-form-item ant-form-item-control-input'}>
                        <CustomValidFormInput
                            placeholder="아이디"
                            control={saveFormControl}
                            onChangeValue={(v) => {
                            }}
                            {...saveFormRegister('userId', {required: '아이디를 입력해주세요.'})}
                        />
                        <CustomValidFormInput
                            type={'password'}
                            placeholder="비밀번호"
                            required={true}
                            control={saveFormControl}
                            onChangeValue={(v) => {
                            }}
                            {...saveFormRegister('passwd', {required: '비밀번호를 입력해주세요.'})}
                            onKeyPress={handleKeyPress}
                        />
                    </div>

                    <CustomButton className='btn' type="primary"
                                  onClick={saveFormHandleSubmit(handleLogin)}>로그인</CustomButton>

                    <div className='box'>
                        <CustomValidFormCheckbox
                            name={'isRememberId'}
                            control={saveFormControl}
                            >아이디 저장</CustomValidFormCheckbox>

                        <div className='find'>
                            <a className='link' onClick={() => setFindIdOpen(true)}>아이디찾기</a>
                            <a className='link' onClick={() => setFindPasswordOpen(true)}>비밀번호찾기</a>
                        </div>
                    </div>


                    <div className='copy-right'>
                        Copyright © 국가지점번호 센서관리 시스템. All Rights Reserved.
                    </div>
                </form>

                <Modal open={findIdOpen}
                       onCancel={() => setFindIdOpen(false)}
                       footer={null}
                       title={'아이디찾기'}
                       destroyOnClose={true}>
                    <FindIdPopup onClose={() => setFindIdOpen(false)}/>
                </Modal>

                <Modal open={findPasswordOpen}
                       onCancel={() => setFindPasswordOpen(false)}
                       footer={null}
                       title={'비밀번호찾기'}
                       destroyOnClose={true}>
                    <FindPasswordPopup onClose={() => setFindPasswordOpen(false)}/>
                </Modal>
            </div>

        </>
    );

};

export default Login;
